import React from "react"
import Link from "@material-ui/core/Link";
import HtmlContent from "../utils/htmlContent"
import SharpImage from "../utils/sharpImage"
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import FeaturedPostStyles from "./featuredPost.styles";
import StyledLinkSecondary from "../common/styledLinkSecondary";
import { postUrl } from "../utils/urls";


export const FeaturedPost = ({ post }) => {
    const classes = FeaturedPostStyles();

    const toPath = postUrl(post);
    //const toPath = `news/blog/${post.slug.raw}`;
    if (post.featuredImage) {
        console.log("Has featured image", post.featuredImage);
    }
    return (
        <div className={classes.featuredPostContainer}>
            <div className={classes.featuredPostImgContainerStyles}>
                {post.featuredImage ?
                    <div className={classes.featuredPostImgContainerStyles}>
                        <SharpImage file={post.featuredImage.node.localFile} title={post.featuredImage.node.title} altText={post.featuredImage.node.altText} />
                    </div>
                    : <></>}
            </div>
            <Box className={classes.featuredPostSummaryContainer}>
                <Typography variant="caption">{post.author ? post.author.raw : "No Author"}</Typography>
                <Typography variant="h5" className={classes.title}><Link href={toPath} color="inherit">{post.title ? post.title.raw : "Untitled"}</Link></Typography>
                <div className={classes.content}><HtmlContent content={post.content.excerpt} /></div>
                <StyledLinkSecondary href={toPath} className={classes.link}>View Post</StyledLinkSecondary>
            </Box>
        </div>
    );
}

export default FeaturedPost
